module.exports = "<dt-entities-autocomplete entities=$ctrl.labels on-change=$ctrl.changed($event) on-add=$ctrl.added($event) on-remove=$ctrl.removed($event) on-search=$ctrl.search($event) require-match=::$ctrl.requireMatch editable=$ctrl.editable placeholder=\"{{ $ctrl.placeholder }}\" secondary-placeholder=\"{{ $ctrl.secondaryPlaceholder }}\" text-key=name></dt-entities-autocomplete>";


//////////////////
// WEBPACK FOOTER
// ./app/common/labels-autocomplete/autocomplete.html
// module id = /t3i
// module chunks = 1